import React from "react";
import { Outlet } from "react-router-dom";

export default function TipLayout() {
    return(
        <>
            <main style={{ padding: '1rem 0' }}> 
                <Outlet />
            </main>
        </>
    )
}